import React from 'react';
import {Flex} from '@chakra-ui/react';
import styled from 'styled-components';

const TabBtn = styled.button<{$active: boolean}>`
  flex: 1;
  padding: 10px 0;
  font-family: Gordita;
  font-size: 14px;
  font-weight: ${(props) => (props.$active ? '700' : '400')};
  color: ${(props) => (props.$active ? '#1A1A1A' : '#757D84')};
  background: none;
  border: none;
  border-bottom: 2px solid ${(props) => (props.$active ? '#1A1A1A' : 'transparent')};
  cursor: pointer;
  transition: all 0.15s ease;

  &:focus-visible {
    outline: 2px solid #1A1A1A;
    outline-offset: -4px;
    border-radius: 2px;
  }
`;

export interface TabItem<T extends string> {
  value: T;
  label: string;
  panelId?: string;
}

export interface TabSwitcherProps<T extends string> {
  tabs: ReadonlyArray<TabItem<T>>;
  activeTab: T;
  onChange: (tab: T) => void;
  ariaLabel?: string;
}

function TabSwitcher<T extends string>({
  tabs,
  activeTab,
  onChange,
  ariaLabel,
}: TabSwitcherProps<T>) {
  return (
    <Flex role="tablist" aria-label={ariaLabel} px={0} borderBottom="1px solid #F0F0F0" w="100%">
      {tabs.map((tab) => {
        const isActive = tab.value === activeTab;
        return (
          <TabBtn
            key={tab.value}
            role="tab"
            type="button"
            aria-selected={isActive}
            aria-controls={tab.panelId}
            tabIndex={isActive ? 0 : -1}
            $active={isActive}
            onClick={() => onChange(tab.value)}>
            {tab.label}
          </TabBtn>
        );
      })}
    </Flex>
  );
}

export default TabSwitcher;
